<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("feature", 2) }}
      </div>
      <router-link class="btn-blue" to="features"
        >{{ $tc("feature", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Features"
          :key="index"
          v-if="item.fieldname !== 'feature_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
            </div>
            <p
              v-if="submitted && errors.has(item.fieldname)"
              class="error_message"
            >
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'module_id'">
              <div class="dropdown-curve-container">
                <label class="shift-up">{{ $tc(item.label, 1) }}</label>
                <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                >
                <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Module"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchModule()"
                        v-on:keydown="onSearchModule()"
                        v-model="searchModule"
                      />
                    </div>
                  <b-dropdown-item
                    v-for="(dropdownItem, dropdownIndex) in moduleList"
                    :key="dropdownIndex"
                    href="#"
                    @click="
                      onDropdownChange($event, item.label, dropdownItem, index)
                    "
                    name="select_module"
                    id="select_module"
                    >{{ dropdownItem.module_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <p
                  v-if="submitted && item.dropdownSelected.length <= 0"
                  class="error_message"
                >
                  Please Select Module
                </p>
              </div>
            </div>
          </div>

          <div v-if="item.type === 'radio'" class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch"> -->
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="item.fieldvalue"
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="features">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Features from "@/helper/formJSONMaster/Features";

export default {
  data() {
    return {
      btenable: false,
      messagemodule: "Please Select Module.",
      Features: Features.ms_features,
      Methods: Features.Methods,
      submitted: false,
      moduleList: [],
      moduleListCopy: [],
      searchModule: "",
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    resetHandler: function () {
      this.Features.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        }
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onSearchModule: function () {
      if(this.searchModule && this.searchModule.length > 0){
        this.moduleList = this.moduleListCopy.filter((x) => {
          return x.module_name.toLowerCase().includes(this.searchModule.toLowerCase());
        });
      }else{
        this.moduleList = this.moduleListCopy;
      }
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            console.log("obj :", obj);
            this.Features.map((x, index) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
                // x.dropdownSelected = obj[x.fieldname];
                this.getModuleList(obj[x.fieldname], index);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getModuleList: function (value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "",
        tableName: "ms_modules",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data && data.data.length > 0) {
            this.moduleList = data.data;
            this.moduleListCopy = data.data;
            let array = this.moduleList.filter((x) => x.module_id === value);
            if (value && index && array.length > 0) {
              this.Features[index].dropdownSelected = array[0].module_name;
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      this.Features[mainIndex].fieldvalue = item.module_id;
      this.Features[mainIndex].dropdownSelected = item.module_name;
    },
    // onUpdateHandler: function () {
    //   // let body = this.getRequestBody("PUT", this.Features, {
    //   //   ...this.Methods,
    //   //   params: { id: this.$route.query.id }
    //   // });
    //   // MasterService.GlobalRequest(body)
    //   //   .then(response => {
    //   //     const { data } = response;
    //   //     if (data.status) {
    //   //       console.log("here :", data);
    //   //       this.$router.push({
    //   //         path: "/master/features"
    //   //       });
    //   //     } else {
    //   //       console.log("show error :", data.message);
    //   //     }
    //   //   })
    //   //   .catch(error => {
    //   //     console.log("show error :", error);
    //   //   });

    //   this.submitted = true;
    //   this.$validator.validate().then((valid) => {
    //     console.log("valid :", valid);
    //     if (valid) {
    //       this.btenable = true;
    //       console.log("valid :", valid);
    //       let body = this.getRequestBody("PUT", this.Distributors, {
    //         ...this.Methods,
    //         params: { id: this.$route.query.id },
    //       });
    //       console.log("body =>:", body);

    //       MasterService.GlobalRequest(body)
    //         .then((response) => {
    //           this.btenable = false;
    //           const { data } = response;

    //           if (data.status) {
    //             console.log("here :", data);
    //             this.$router.push({
    //               path: "/master/features",
    //             });
    //           } else {
    //             console.log("show error :", data.message);
    //             this.$toasted.show(Error(data.message));
    //           }
    //         })
    //         .catch((error) => {
    //           console.log("show error2 :", error);
    //         });
    //     } else {
    //       console.log("else :");
    //     }
    //   });
    // },
    onUpdateHandler() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          let body = this.getRequestBody("PUT", this.Features, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });
          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.$router.push({
                  path: "/master/features",
                });
              } else {
                console.log("show error:", data.message);
                this.$toasted.show(Error(data.message));
              }
            })
            .catch((error) => {
              this.btenable = false;
              console.log("show error2:", error);
            });
        } else {
          console.log("Validation failed");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/FeaturesComponents/editFeature.vue